import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class ResourceService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/resources', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/resource/{id}', { id: id }), params);
	}

	async getEvaluationsById(id, params) {
		return this.api.get(urlReplace('/secure/resource/{id}/evaluations', { id: id }), params);
	}

	//post put delete
}